<template lang="pug">
    ib-application(
        layout="full",
        :translations="translations",
        row,
        grow,
        class="si-quotes-view"
    )
        div(
            v-if="title",
            class="insety-16",
            v-text="title"
        )
        SiQuotes
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import SiQuotes from '../components/SiQuotes.vue'

    export default {
        name: 'index',

        data() {
            return {
                translations: _i18n.translations,
                title: '',
            }
        },

        components: {
            SiQuotes
        },

        methods: {
            mount(mountTo, title) {
                if (!window.sbiApp._isMounted) {
                    console.debug('mount for the first time');
                    window.sbiApp.$mount();
                }
                const app = document.getElementById(mountTo);
                if (!app) {
                    this.$notify('Can\'t instantiate SI quotes app');
                    return;
                }
                app.innerHTML = '';
                app.appendChild(window.sbiApp.$el);
                if (title) {
                    this.title = title;
                }
            }
        }
    }
</script>

<style lang="less">
    .si-quotes-view {
        height: calc(~'100vh - 240px');
    }
</style>